import type { User } from '@paintscout/api'
import { removeAuth0Prefix, getHighestRole } from '@paintscout/util'

/**
 * Decides whether a user can be assigned a task (powers the assignee dropdown's includeUser filter).
 *
 * Effective permissions come from app_metadata.resolvedPermissions, which the server computes and
 * delivers on the lightweight searchUsers payload. We deliberately do NOT re-derive permissions on
 * the client here — the raw customPermissions/permissions needed for that are not sent to the app.
 */
export function canAssignTaskToUser(
  user: User,
  dealAssignedUsers?: Record<string, { assigned?: boolean }>,
  dealOwnerId?: string
) {
  const role = getHighestRole(user.app_metadata?.roles ?? [])

  if (['team', 'admin', 'viewer'].includes(role)) {
    return true
  }

  const permissions = user.app_metadata?.resolvedPermissions ?? []

  // TODO: should there be deal assignment for painters / crews? Right now painters can be assign tasks on any deal, not just their 'assigned' deals.
  if (role === 'painter' && permissions.includes('contribute:assigned-deals')) return true

  if (role === 'core') {
    const userId = removeAuth0Prefix(user.user_id)
    return (
      dealAssignedUsers?.[userId]?.assigned === true ||
      dealOwnerId === userId ||
      permissions.includes('write:all-tasks')
    )
  }

  return false
}
